module.exports = __webpack_public_path__ + "static/media/serena_pacman_tex.eb1afe09.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/serenaPacman/serena_pacman_tex.png
// module id = 148
// module chunks = 0